// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__0SVAD","mainContent":"Home_mainContent__m32ig","fadeIn":"Home_fadeIn__x4IOr"};